import {TheRave} from "../TheRave";
import {Layers, TheRaveLayers} from "./TheRaveLayers";
import {TweenLite, TimelineLite, Power3} from "gsap";
import {TheRaveReelView} from "../reels/TheRaveReelView";
import {TheRaveSound} from "../sound/TheRaveSound";

export class ReelHighlighter extends PIXI.Sprite {
    private readonly LINK_SEQUENCE: any =
        {
            2: [[1, 2], [2, 1]],
            3: [[1, 2, 3], [3, 2, 1], [2, 3, 1], [2, 1, 3]],
            4: [[1, 2, 3, 4], [2, 3, 4, 1], [2, 3, 1, 4], [2, 1, 3, 4], [3, 4, 2, 1], [3, 2, 1, 4], [3, 2, 4, 1], [4, 3, 2, 1]],
            5: [[1, 2, 3, 4, 5], [2, 1, 3, 4, 5], [2, 3, 4, 1, 5], [2, 3, 1, 4, 5], [2, 3, 4, 5, 1], [3, 4, 2, 1, 5], [3, 4, 2, 5, 1],
                [3, 4, 5, 2, 1], [4, 5, 3, 2, 1], [4, 3, 5, 2, 1], [4, 3, 2, 1, 5], [4, 3, 2, 5, 1]]
        };
   //private readonly LINK_SEQUENCE: any =
   //    {
   //        2: [[1, 2]],
   //        3: [[1, 2, 3]],
   //        4: [[1, 2, 3, 4]],
   //        5: [[1, 2, 3, 4, 5]]
   //    };

    private container: PIXI.Sprite;
    private tl: TimelineLite;
    private _isShowing: boolean = false;
    private _linkedReel: number[] = [];
    private _frames: PIXI.spine.Spine[] = [];
    private smoke: PIXI.spine.Spine;

    constructor() {
        super();
        this._isShowing = false;
        this.smoke = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(`GASBACKGROUND`))
        this.container = new PIXI.Sprite();
        this.container.anchor.set(0.5, 0);
        this.container.position.set(0, 343);
        //this.tmpDebugHandler();
    }

    public show(doLinkedReels: boolean[]): void {
        const tl: TimelineLite = new TimelineLite();
        this._isShowing = true;
        let linkedReels: number[] = [];

        doLinkedReels.forEach((isLinked: boolean, i: number) => {
            if (isLinked) {
                linkedReels.push(i);
            }
        });

        while (this._frames.length > 0) {
            this.container.removeChild(this._frames[0]);
            this._frames.shift();
        }
        if (this.smoke) {
            TheRaveLayers.getLayer(Layers.WAYS)?.removeChild(this.smoke);
        }
        const transformDuration: number = 1,
            framesNum: number = linkedReels.length,
            startLinkReelId: number = linkedReels[0],
            sequences: number[][] = this.LINK_SEQUENCE[framesNum],
            sequence: number[] = sequences[Math.floor(Math.random() * sequences.length)],
            containerX: number = TheRaveReelView.SYMBOL_WIDTH * startLinkReelId + 70,
            smoke: PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(`GASBACKGROUND`)),
            frameLoop: PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(`${framesNum - 1}T${framesNum}`));
        this.smoke = smoke;

        let frameX: number[] = [], mostLeftReel:number[] = [], leftReel = 6;
        sequence.forEach((toReel: number, i: number) => {
            leftReel = Math.min(leftReel, toReel+startLinkReelId-1);
            mostLeftReel.push(leftReel),
            frameX.push(leftReel * 144 - containerX + 70);
        });
        //console.log(sequence)
        tl.add([() => {
            this.container.position.x = containerX;
            smoke.position.x = 353;
            smoke.position.y = 445;
            TheRaveSound.playSoundEffect("sidechainAirStarts");
            TheRaveSound.playSoundEffect("sidechainAirLoop", 50);
            smoke.state.setAnimation(0, "loop", true);
            TheRaveLayers.getLayer(Layers.FOREGROUND_TOP)?.addChild(this.container);
            TheRaveLayers.getLayer(Layers.WAYS)?.addChild(smoke);
        },
            TweenLite.to(this.container, {alpha: 1, duration: 0.1, ease: Power3.easeOut})
        ], 0);

        this._linkedReel = linkedReels;
        let delay=0;
        linkedReels.forEach((reel: number, i: number) => {
            tl.add(() => {
                const frameTransform: PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(i === 0 ? `1T2` : `${i}T${i + 1}`));
                const dir: string = i === 0 ? "landing" : (sequence[i] > sequence[i - 1] ? "right" : "left");
                frameTransform.position.x = (i === 0 ? frameX[i] : frameX[i - 1]);
                frameTransform.state.setAnimation(0, dir, false);
                this.container.addChild(frameTransform);
                if (this._frames.length > 0) {
                    this.container.removeChild(this._frames[0]);
                    this._frames.shift();
                }
                this._frames.push(frameTransform);
            }, delay);
            tl.add(() => TheRaveSound.playSoundEffect(`linkedReel${i+1}`), (delay + (i===0?0:0.7)));
            delay += (i===0?0.6:transformDuration);
            tl.add(() => TheRave.reels[sequence[0]+startLinkReelId-1].setLinkedNum(i+1,mostLeftReel[i]), delay);
        });
        tl.add(() => {
            TheRave.background.playShakeEffect();
            frameLoop.state.setAnimation(0, "loop", true);
            this.container.addChild(frameLoop);
            if (this._frames.length > 0) {
                this.container.removeChild(this._frames[0]);
                this._frames.shift();
            }
            this._frames.push(frameLoop);
        }, delay);
        this.tl = tl;
    }

    public skip(): void {
        if (this.tl) {
            this.tl.timeScale(3);
        }
    }

    public hide(): void {
        if (!this._isShowing) {
            return;
        }
        this._isShowing = false;
        new TimelineLite().add([
            () => this._linkedReel.forEach((reel: number) => TheRave.reels[reel].reelView.resetMask(1)),
            TweenLite.to(this.container, {alpha: 0, duration: 0.2, ease: Power3.easeOut}),
            TweenLite.to(this.smoke, {alpha: 0, duration: 0.2, ease: Power3.easeOut})])
            .add(() => {
                TheRaveSound.stopSoundEffect("sidechainAirLoop");
                while (this._frames.length > 0) {
                    this.container.removeChild(this._frames[0]);
                    this._frames.shift();
                }
                TheRaveLayers.getLayer(Layers.FOREGROUND_TOP)?.removeChild(this.container);
                if (this.smoke) {
                    TheRaveLayers.getLayer(Layers.REEL_FRAME)?.removeChild(this.smoke);
                }
            });
    }

    /* private tmpDebugHandler():void{
        const ref = this;
        document.addEventListener("keydown", function (e) {
            var keyCode = e.keyCode;
            //console.log("KeyCode: " + keyCode);

            switch (keyCode) {
                case 48:
                    break; // 0
                case 49:
                    break; // 1
                case 50:
                    ref.test(2);
                    break; // 2
                case 51:
                    ref.test(3);
                    break; // 3
                case 52:
                    ref.test(4);
                    break; // 4
                case 53:
                    ref.test(5);
                    break; // 5
                case 54:
                    ref.test(6);
                    break; // 6
                case 55:
                    ref.test(7);
                    break; // 7
                case 56:
                    ref.test(8);
                    break; // 8
                case 57:
                    ref.test(9);
                    break; // 9
            }
        }, false);

    }

    private test(nr:number):void{
        const tl:TimelineLite = new TimelineLite()

        switch (nr) {
            case 2:
                tl.add(()=>{
                    this.show([true,true,false,false,false])
                });
                break; // 6
            case 3:
                tl.add(()=>{
                    this.show([false,true,true,true,false])
                });
                break; // 7
            case 4:
                tl.add(()=>{
                    this.show([false,true,true,true,true])
                });
                break; // 8
            case 5:
                tl.add(()=>{
                    this.show([true,true,true,true,true])
                });
                break; // 9
            case 6:
                tl.add(()=>{
                    this.show([false,false,false,true,true])
                });
                break; //
            case 8:
                tl.add(()=>{
                    this.show([true,true,true,false,false])
                });
                break; // 6
            case 7:
                tl.add(()=>{
                    this.show([false,false,true,true,true])
                });
                break; // 6
        }
        tl.add(()=>{this.hide();},nr*2+1);
    }*/
}